import styled from "styled-components";
import ThemeColors from "../../themes/colors";

export const StyledPasswordInput = styled.div`
  .ant-input-password {
    font-size: 1rem;
    border-radius: 0.75rem;
    padding: 0.688rem;
    font-family: "Urbanist";
    font-weight: 500;
    background-color: ${ThemeColors.Gray400};
    border-color: ${ThemeColors.Gray500};
  }
`;
